import styled from 'styled-components';

import LoadingSwitchTransition from '@/components/LoadingSwitchTransition';
import ModalLayout from '@/layouts/ModalLayout';
import colors from '@/design/colors';
import shadows from '@/design/shadows';
import { HeadingSmall, Text } from '@/design/typography';

export const LoadingTransition = styled(LoadingSwitchTransition)`
  display: flex;
  flex-direction: column;
`;

export const ModalProtocolo = styled(ModalLayout)`
  width: 480px;
`;

export const ModalProtocoloOptions = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 16px;
`;

export const ModalProtocoloOption = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 12px;

  flex: 1;
  padding: 24px 16px;

  background-color: ${colors.white};
  border: 1px solid ${colors.gray100};
  border-radius: 8px;

  color: ${colors.blackAlpha200};
  transition: box-shadow 0.3s ease-in-out, color 0.3s ease-in-out;

  > svg > path {
    stroke: ${colors.blackAlpha200};
    transition: stroke 0.3s ease-in-out;
  }

  span {
    ${Text(16)};
    color: inherit;
    text-align: center;
  }

  &:hover:not(:disabled) {
    box-shadow: ${shadows.smallShadow};
    color: ${colors.purple100};

    > svg > path {
      stroke: ${colors.purple100};
    }
  }

  &:disabled {
    color: ${colors.gray100};
    cursor: not-allowed;

    > svg > path {
      stroke: ${colors.gray100};
    }
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  h1 {
    ${HeadingSmall(16)};
  }

  a {
    ${HeadingSmall(14)};
    color: ${colors.blackAlpha200};

    &:hover {
      text-decoration: underline;
    }
  }
`;
